import React from "react";
import { Card, Col, Nav, Row } from "react-bootstrap";

function InformationScreen() {
  return (
    <Row className="align-items-center">
      <Nav.Link style={infoStyle} href="/privacyPolicy">
        Privacy Policy
      </Nav.Link>
      <Nav.Link style={infoStyle} href="/refundPolicy">
        Refund Policy
      </Nav.Link>
      <Nav.Link style={infoStyle} href="/terms-and-conditions">
        Terms and Conditions
      </Nav.Link>
      <Nav.Link style={infoStyle} href="/contactUs">
        Contact Us
      </Nav.Link>
    </Row>
  );
}

const infoStyle = {
  color: "black",
  cursor: "pointer",
  textDecoration: "underline",
  margin: "1rem",
};

export default InformationScreen;
